import { InAppState } from "../base/InAppState";
import '../../components/template/template-card';
import template from './TemplateListTemplate.html';

import { Template } from "../../models/Template";

export class TemplateListState extends InAppState
{
    static ROUTE = '/template/list';
    static ID = 'template-list';

    async enter()
    {
        this.templates = [];
        this.currentFilter = 'all';
        const { result } = await this.app.api.get( '/template' );
        if ( result.status === 200 && result.data.length > 0 )
        {
            result.data.forEach( ( template ) =>
            {
                this.templates.push( new Template( template ) );
            });
        }

        this.render();
        this._bindCards();
        this._bindFilterNavigation();
        this._bindDemoCards();

        this.addEventListener(
            this.app.view.pageContent,
            'delete',
            ( e ) => {
                if ( e.detail?.templateId )
                {
                    this.deleteTemplate( e.detail.templateId );
                }
            }
        );
    }

    _bindCards()
    {
        const filteredTemplates = this._getFilteredTemplates();
        const cards = this.app.view.pageContent.querySelectorAll( 'template-card' );
        cards.forEach( ( card, index ) => {
            if ( filteredTemplates[ index ] )
            {
                card.template = filteredTemplates[ index ];
            }
        });
    }

    _bindDemoCards()
    {
        const demoCards = this.app.view.pageContent.querySelectorAll( '.demo-template-card' );
        demoCards.forEach( ( card ) =>
        {
            this.addEventListener( card, 'click', () =>
            {
                this.createDemoTemplate( card.dataset.demoId );
            });
        });
    }

    async createDemoTemplate( demoTemplateId )
    {
        const DEMO_NAMES = {
            "text-formatting": "Text & Formatting",
            "image-placeholder": "Image Placeholders",
            "conditionals-loops": "Conditionals & Loops",
            "invoice": "Invoice"
        };

        const confirmed = await this.app.view.confirm(
            "Create Demo Template",
            `Create the "${DEMO_NAMES[ demoTemplateId ]}" demo template?`,
            "Create"
        );

        if ( true === confirmed )
        {
            const pageContent = this.app.view.pageContent;
            this.app.view.blockUI( pageContent, 'Creating demo template...' );

            const { result } = await this.app.api.post( '/template/example', {
                demoTemplateId
            });

            this.app.view.unblockUI( pageContent );

            if ( result.status === 201 )
            {
                this.app.view.toast( "Demo template created successfully", "success" );
                this.templates.push( new Template( result.data ) );
                this.render();
                this._bindCards();
                this._bindFilterNavigation();
                this._bindDemoCards();
            }
            else
            {
                this.app.view.toast( "Failed to create demo template", "error" );
            }
        }
    }

    _bindFilterNavigation()
    {
        const filterLinks = this.app.view.pageContent.querySelectorAll( '[data-filter]' );
        filterLinks.forEach( ( link ) => {
            this.addEventListener( link, 'click', ( e ) => {
                e.preventDefault();
                const filter = link.dataset.filter;
                if ( filter !== this.currentFilter )
                {
                    this.currentFilter = filter;
                    this.render();
                    this._bindCards();
                    this._bindFilterNavigation();
                    this._bindDemoCards();
                }
            });
        });
    }

    _getFilteredTemplates()
    {
        if ( this.currentFilter === 'all' )
        {
            return this.templates;
        }
        const statusFilter = this.currentFilter.toUpperCase();
        return this.templates.filter( ( template ) => template.status === statusFilter );
    }

    async deleteTemplate( templateId )
    {
        const performDeletion = await this.app.view.confirm(
            "Delete Template",
            "Do you really want to delete this template?"
        );

        if ( true === performDeletion )
        {
            const pageContent = this.app.view.pageContent;
            this.app.view.blockUI( pageContent, 'Deleting template...' );

            const { result } = await this.app.api.delete( `/template/${templateId}` );

            this.app.view.unblockUI( pageContent );

            if ( result.status === 200 )
            {
                this.app.view.toast( "Template deleted successfully", "success" );
                const idxToDelete = this.templates.findIndex( ( template ) => template.id === templateId );
                if ( idxToDelete > -1 )
                {
                    this.templates.splice( idxToDelete, 1 );
                }
                this.render();
                this._bindCards();
                this._bindFilterNavigation();
                this._bindDemoCards();
            }
            else
            {
                this.app.view.toast( "Template deletion failed", "error" );
            }
        }
    }

    render()
    {
        this.app.view.render(
            this.app.view.pageContent,
            template,
            {
                templates : this._getFilteredTemplates(),
                currentFilter : this.currentFilter,
                totalCount : this.templates.length
            }
        );
    }

    getContentHeaderData()
    {
        return {
            title: 'Templates',
            breadcrumb: [ 'Work', 'List of templates' ]
        };
    }
}
